<template>
  <div v-if="modalShow" class="base-modal">
    <div class="modal-content scroll-bar" :class="customClass">
      <div
        class="flex items-center relative w-full"
        :class="$slots.header ? 'justify-between' : 'justify-end'"
      >
        <div
          v-if="$slots.header"
          class="py-3 text-heading-3 text-primary-1 w-full"
        >
          <slot name="header">
            <div
              class="border-b border-gray-2 text-center px-5 py-3 text-mobile-heading-5 text-gray-1"
            />
          </slot>
        </div>
        <div
          v-if="showCloseBtn"
          class="absolute ltr:right-0 rtl:left-0 top-0 z-10"
        >
          <icon-close-bold
            class="text-[#8c8c8c] text-[24px] !mb-0 cursor-pointer"
            :class="closeBtnClass"
            @click="closeModal"
          />
        </div>
      </div>
      <div class="text-paragraph-2 text-gray-1">
        <slot name="content" />
      </div>
    </div>
    <div class="modal-overlay" @click="closeModal" />
  </div>
</template>

<script setup lang="ts">
defineProps({
  modalShow: {
    type: Boolean,
    default: true,
  },
  customClass: {
    type: String,
    default: "",
  },
  closeBtnClass: {
    type: String,
    default: "",
  },
  showCloseBtn: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(["update:modal-show"]);
function closeModal() {
  emit("update:modal-show", false);
}
</script>
